import { FIELDS } from "../configurations/Urls";
import Session from "../helpers/SessionHelper";
import axios from "axios";

const WellSummaryService = {
  async getWellSummary(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(`${FIELDS}/well/summary`, payload, {
      headers: headers,
    });
    return response;
  },
};
export default WellSummaryService;
